/* Project Import will be here */
import { authTokenKey } from "services/index";
/* Project Import will be here */

/* Phone number */
type ILoginId = string | number;
type IPassword = string | number;

export type IRequestLoginOtpParams = {
  data: {
    loginId: ILoginId
  },
  headers: {
    [authTokenKey]: string
  }
};

export type ILoginParams = {
  loginId: ILoginId,
  password: IPassword
};

export type INewLoginParams = {
  loginId: ILoginId,
  query: any
};

export type INewLoginPasswordParams = {
  loginId: ILoginId,
  password: string
};

export type INewLoginChangePasswordParams = {
  NewPassword: string,
  ConfirmPassword: string
};

export type IRequestChangeMobNoParams = {
  data: {
    oldmobileno: ILoginId,
    mobileno: number
  }
};
export type IRequestMobChangeParams = {
  data: {
    mobileno: ILoginId
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangeMobileNoParams = {
  data: {
    mobileno: ILoginId,
    otp: string | number
  }
};

export type IUpdateMobileNoParams = {
  data: {
    mobileno: ILoginId,
    otp: string | number
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IResetPasswordParams = {
  data: {
    password: IPassword
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangePasswordParams = {
  data: {
    password: IPassword,
    newPassword: IPassword
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangePassActionParams = {
  Password: string | number,
  NewPassword: string | number,
};

export type IResetPassActionParams = {
  password: string | number
};